import { createSlice } from "@reduxjs/toolkit"
import { ExportsState } from "./types"

const initialState = {
    kmlByFlightId: {},
} as ExportsState

export const slice = createSlice({
    name: "exports",
    initialState,
    reducers: {},
})

const {
    //actions,
    reducer,
} = slice

// export {} = actions

export default reducer
